import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-school-banner',
  templateUrl: './language-school-banner.component.html',
  styleUrls: ['./language-school-banner.component.scss']
})
export class LanguageSchoolBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
